import { useSyncExternalStore } from 'react'
import { PMState } from '../../../types/mfc'
import { pubSub } from '../../app-state/pubSub'
import { PMSTATE } from '../../state/state.pm'

const subMessagesState = () => (callback) =>
    pubSub.MESSAGES.on(`state`, callback)

const getMessagesStateSelector = (key) => () => PMSTATE[key]

export const usePMSelector = <T extends keyof PMState>(
    attribute: T,
): PMState[T] => {
    return useSyncExternalStore(
        subMessagesState(),
        getMessagesStateSelector(attribute),
        getMessagesStateSelector(attribute),
    )
}
